import React, { Component } from 'react';
import AdminNavLinks from './admin-nav-links';
import { withRouter } from 'react-router-dom';
import './nav.scss';

export class Nav extends Component {

  /**
   * Capture information about a keystroke that happened in the side nav bar.
   * @param {object} ev The onKeyDown event.  Use this to get the actual keystroke code.
   * @param {object} navDetail See definition in layout reducer.
   */
  setNavFromKey( ev, navDetail ) {
    const { layoutActions } = this.props;
    layoutActions.setNavFromKey(ev, navDetail);
  }

  render() {
    const { location } = this.props;
    const { pathname } = location || {};

    return (
      <nav id="sidenav" aria-label="Navigation">
        <AdminNavLinks setKey={(e, n) => this.setNavFromKey(e, n)} pathname={pathname} />
      </nav>
    );
  }
}

Nav.propTypes = {
};

export default withRouter(Nav);
